import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/styles";
import CategoriesListComponent from "./components/categoriesListComponent/CategoriesListComponent";
import { getSymptoms } from "../../services/commonservices";
import { useDispatch, useSelector } from "react-redux";
import {
  changeDiseasesAction,
  changeSearchTextAction,
  changeSelectedCategoriesAction,
  changeSymptomsAction,
  changeSymptomsPageSizeAction,
  changeTotalSymptomsAction,
} from "../../reducers/searchOmimState";
import DiseasesTableComponent from "../common/diseasesTableComponent/DiseasesTableComponent";
import { formatCategoriesList } from "../../utils/utils";
import { KEY_ENTER, ROLES_ALL, ROUTES_HOME, SYMPTOMS_PAGE_SIZE } from "../../utils/constants";
import withAuthorization from "../common/auth/withAuthorization";
import SearchBarComponent from "../common/SearchBarComponent";
import SymptomsComponent from "../common/symptomsComponent/SymptomsComponent";
import BackButtonComponent from "../common/BackButtonComponent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { useIntl } from "react-intl";

const useStyles = makeStyles((theme) => ({
  divContainer: {
    padding: "1rem",
    gap: "2rem",
    display: "grid",
    overflow: "scroll",
    maxHeight: "calc(100vh - 160px)",
    justifyContent: "stretch",
  },
  actionButtons: {
    display: "flex",
    gap: "1rem",
    padding: "0 1rem",
    flexWrap: "wrap",
    width: "100%",
    justifyContent: "space-between",
  },
  primaryButton: theme.primaryPinkButton,
  firstCap: {
    textTransform: "lowercase !important",
    "&:first-letter": {
      textTransform: "capitalize !important",
    },
  },
  divHeader: {
    display: "flex",
    gap: "2rem",
  },
  content: {
    margin: "0 auto",
  },
  symptomsCategories: {
    display: "grid",
    gap: "1rem",
    gridTemplateColumns: "auto 1fr 1fr",
    columnGap: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: " 1fr",
    },
  },
  paper: {
    borderRadius: "17px",
    boxShadow: "0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)",
    padding: "2rem",
    backgroundColor: "white",
    display: "grid",
    [theme.breakpoints.down("sm")]: {
      boxShadow: " none",
      padding: 0,
    },
  },
  paperSelectCategories: {
    borderBottomRightRadius: "0",
    borderTopRightRadius: "0",
    display: "grid",
    gap: "1rem",
  },
  paperSelect: {
    borderRadius: "0",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "20px",
    },
  },
  paperResult: {
    borderBottomLeftRadius: "0",
    borderTopLeftRadius: "0",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "20px",
    },
  },
  backButton: {
    minWidth: 150,
  },
  backButtonLabel: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    "&:hover": {
      color: `${theme.palette.selected.main} !important`,
    },
  },
}));

const SearchOmimComponent = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const intl = useIntl();

  const searchText = useSelector((state) => state.searchOmim.searchText);
  const categoriesSelected = useSelector((state) => state.searchOmim.selectedCategories);
  const symptoms = useSelector((state) => state.searchOmim.symptoms);
  const mobileVersion = useSelector((state) => state.common.mobileVersion);

  const [currentSection, setCurrentSection] = useState(1);

  const handleTextChange = (event) => {
    dispatch(changeSearchTextAction(event.target.value));
  };

  const handleSearchSuccess = (response) => {
    dispatch(changeSymptomsPageSizeAction(parseInt(response.headers["pagination-page-size"])));
    dispatch(changeTotalSymptomsAction(parseInt(response.headers["pagination-total-results"])));
    dispatch(changeSymptomsAction(response.data));
  };

  const handleSearchOnclick = () => {
    const categories = formatCategoriesList(categoriesSelected);
    getSymptoms(searchText, categories, SYMPTOMS_PAGE_SIZE, 0, handleSearchSuccess);
  };

  useEffect(() => {
    if (!!Object.keys(categoriesSelected)?.length || !!searchText) {
      handleSearchOnclick();
    } else if (!!symptoms?.length) {
      dispatch(changeSymptomsPageSizeAction(null));
      dispatch(changeTotalSymptomsAction(null));
      dispatch(changeSymptomsAction([]));
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoriesSelected]);

  const handleSearchOnKeyDown = (event) => {
    const { key } = event;
    key === KEY_ENTER && handleSearchOnclick();
  };

  useEffect(() => {
    return () => {
      dispatch(changeSearchTextAction(""));
      dispatch(changeSelectedCategoriesAction({}));
      dispatch(changeDiseasesAction([]));
      dispatch(changeSymptomsAction([]));
    };
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSectionChange = (direction) => {
    if (direction === "next") {
      setCurrentSection(currentSection + 1);
    } else if (direction === "prev") {
      setCurrentSection(currentSection - 1);
    }
  };
  return (
    <div className={classes.divContainer}>
      <div className={classes.divHeader}>
        <BackButtonComponent url={ROUTES_HOME} />
        <SearchBarComponent
          handleChange={handleTextChange}
          handleKeyDown={handleSearchOnKeyDown}
          handleClick={handleSearchOnclick}
          placeholder={"searchOmimComponent.input_placeholder"}
          disabled={!searchText}
        />
      </div>
      <div className={classes.symptomsCategories}>
        {currentSection === 1 && (
          <div className={`${classes.paper} ${classes.paperSelectCategories}`}>
            <CategoriesListComponent />
          </div>
        )}
        {(currentSection === 2 || !mobileVersion) && (
          <div className={`${classes.paper} ${classes.paperSelect}`}>
            <SymptomsComponent />
          </div>
        )}
        {(currentSection === 3 || !mobileVersion) && (
          <div className={`${classes.paper} ${classes.paperResult}`}>
            <DiseasesTableComponent showScore={true} />
          </div>
        )}
        <div className={classes.actionButtons}>
          {mobileVersion && currentSection > 1 && (
            <Button
              className={`${classes.primaryButton}  ${classes.previous}`}
              onClick={() => handleSectionChange("prev")}
            >
              <Typography className={classes.firstCap}>{intl.formatMessage({ id: "previous" })}</Typography>
            </Button>
          )}
          {mobileVersion && currentSection <= 2 && (
            <Button
              disabled={!Boolean(Object.keys(categoriesSelected).length !== 0)}
              className={`${classes.primaryButton} ${classes.next}`}
              onClick={() => handleSectionChange("next")}
            >
              <Typography className={classes.firstCap}>{intl.formatMessage({ id: "next" })}</Typography>
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default withAuthorization(ROLES_ALL)(SearchOmimComponent);
